import React, { Component, Suspense, lazy } from 'react';

import classNames from 'classnames';
import { Loader } from 'components/loader';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';

import BoxImageUploadFilled from './BoxImageUploadFilled';

import { UPLOAD_STATUS } from '../constants';

import { UploadProptypes } from '@hotmart/club-files-ui';

import './BoxImageUploadActions.scss';

export default class BoxImageUploadActions extends Component {
  // #region setup
  static propTypes = {
    image: PropTypes.object,
    entityType: PropTypes.string,
    full: PropTypes.bool,
    reusable: PropTypes.bool,
    fileUpload: UploadProptypes.fileUpload
  };

  get hasFailed() {
    const { image } = this.props;

    return image.status === UPLOAD_STATUS.FAILED;
  }

  get isUploading() {
    const { image } = this.props;

    return image.origin === 'UPLOAD' && image.status !== UPLOAD_STATUS.FINISHED;
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.image, this.props.image);
  }
  // #endregion

  renderUploadingFailed(image) {
    const FileUploadingFailed = lazy(() => import('./FileUploadingFailed'));

    return <FileUploadingFailed id={image.id} />;
  }

  renderUploading(image) {
    const FileUploading = lazy(() => import('./FileUploading'));

    return <FileUploading {...image} />;
  }

  renderUploadEmpty() {
    const { reusable, fileUpload } = this.props;
    const BoxImageUploadEmpty = lazy(() => import('./BoxImageUploadEmpty'));

    return (
      <Suspense fallback={<Loader />}>
        <BoxImageUploadEmpty reusable={reusable} fileUpload={fileUpload} />
      </Suspense>
    );
  }

  renderInnerDropzone() {
    const { image } = this.props;

    if (this.hasFailed) {
      return this.renderUploadingFailed(image);
    } else if (this.isUploading) {
      return this.renderUploading(image);
    }
  }

  render() {
    const { image, ...props } = this.props;

    const classComponent = classNames(
      'dropzone__action__button',
      'dropzone__action__button--file-status',
      { 'dropzone__action__button--full': props.full }
    );

    if (isEmpty(image)) {
      return this.renderUploadEmpty();
    }

    if (this.hasFailed || this.isUploading) {
      return (
        <div className={classComponent}>
          <Suspense fallback={<Loader />}>
            {this.renderInnerDropzone()}
          </Suspense>
        </div>
      );
    }

    return <BoxImageUploadFilled image={image} {...props} />;
  }
}
